var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cartContainer" }, [
    _c(
      "div",
      {
        class: ["headerIcon", { active: _vm.showCartPanel }],
        on: { click: _vm.clickWidget },
      },
      [
        _c("i", { staticClass: "cartIcon" }),
        _vm._v(" "),
        _c("span", [_vm._v("\n\t\t\t" + _vm._s(_vm.itemCount) + "\n\t\t")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCartPanel,
            expression: "showCartPanel",
          },
        ],
        staticClass: "cartPanel",
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("span", { staticClass: "title" }, [
            _c("i", { staticClass: "cartIcon" }),
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(
                  _vm.$t("cartWidgetPanelHeader", { count: _vm.itemCount })
                ) +
                "\n\t\t\t"
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._l(_vm.items, function (item) {
          return _c("div", { key: item.id, staticClass: "row" }, [
            _c("span", { staticClass: "productTitle" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(item.name) +
                  " (" +
                  _vm._s(item.quantity) +
                  ")\n\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _vm.hasEdit
              ? _c(
                  "span",
                  {
                    staticClass: "removeIcon",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.removeItem(item)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("\n\t\t\t\t\tclose\n\t\t\t\t"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "productPriceInfo" }, [
              _c(
                "span",
                [_c("PriceView", { attrs: { cents: item.price } })],
                1
              ),
            ]),
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "total" },
            [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("total")) + ":\n\t\t\t\t"),
              _c("PriceView", { attrs: { cents: _vm.subTotal } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.itemCount > 0,
                  expression: "itemCount > 0",
                },
              ],
              staticClass: "buttons",
            },
            [
              _c(
                "span",
                { staticClass: "textLink", on: { click: _vm.viewCart } },
                [
                  !_vm.hasEdit
                    ? [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("edit")) +
                            "\n\t\t\t\t\t\t"
                        ),
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("\n\t\t\t\t\t\t\tchevron_right\n\t\t\t\t\t\t"),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "actionbutton cartButton",
                  on: { click: _vm.viewCart },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("subNavbarCartNext")) +
                      "\n\t\t\t\t"
                  ),
                ]
              ),
            ]
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }